import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, useMap, Tooltip } from 'react-leaflet';
import L from 'leaflet';
import { motion } from "framer-motion";
import { KUTCH_MAP_CONFIG, KUTCH_LOCATIONS } from '../Data';

// Reusing your exact Custom Diamond Marker Icon
const diamondIcon = new L.DivIcon({
  className: 'diamond-marker',
  iconSize: [12, 12],
  iconAnchor: [6, 6]
});

// Map Controller for smooth transition
function MapController({ center, zoom }) {
  const map = useMap();
  useEffect(() => {
    map.flyTo(center, zoom, { duration: 2 });
  }, [center, zoom, map]);
  return null;
}

const KutchMap = () => {
  const [activeTab, setActiveTab] = useState('office');

  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: (i = 1) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.1,
        duration: 0.7,
        ease: "easeOut"
      }
    })
  };

  return (
    <div className="mineral-map-section container">

      {/* HEADING */}
      <motion.h2
        className="section-heading"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        viewport={{ once: true }}
      >
     GLOBAL MINERAL SOLUTIONS ROOTED IN KUTCH
      </motion.h2>

      {/* DESCRIPTION */}
      <motion.p
        className="section-text"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        viewport={{ once: true }}
      >
       At <b className='bold'>Iris Impulse India Pvt. Ltd.</b>, we proudly deliver global mineral solutions rooted in Kutch, Gujarat, India, where rich reserves meet advanced infrastructure. Headquartered in Gandhidham, we specialize in the sourcing, processing, and export of high-quality industrial minerals trusted by clients worldwide. Our strong local foundation allows us to maintain consistent quality, competitive pricing, and reliable supply chains that serve industries such as ceramics, paints, plastics, refractories, and construction. With innovation, sustainability, and customer trust at our core, we bridge the gap between Kutch’s natural resources and international demand. By combining global reach with local expertise, <b className='bold'>Iris Impulse India Pvt. Ltd.</b> ensures mineral solutions that empower businesses across continents while strengthening our community and environment.
      </motion.p>

      {/* TABS */}
      <motion.div
        className="tabs"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        {Object.keys(KUTCH_MAP_CONFIG).map((category, i) => (
          <motion.button
            key={category}
            custom={i}
            variants={fadeUp}
            className={activeTab === category ? 'active' : ''}
            onClick={() => setActiveTab(category)}
            whileHover={{ scale: 1.08 }}
            whileTap={{ scale: 0.95 }}
          >
            {KUTCH_MAP_CONFIG[category].label.toUpperCase()}
          </motion.button>
        ))}
      </motion.div>

      {/* MAP WRAPPER */}
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <MapContainer
          center={KUTCH_MAP_CONFIG.office.center}
          zoom={KUTCH_MAP_CONFIG.office.zoom}
          scrollWheelZoom={false}
          className="leaflet-container"
        >
          <TileLayer
            url={`https://{s}.basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}{r}.png?key=${process.env.REACT_APP_CARTO_API_KEY}`}
            attribution='&copy; OpenStreetMap contributors &copy; CARTO'
          />

          <MapController
            center={KUTCH_MAP_CONFIG[activeTab].center}
            zoom={KUTCH_MAP_CONFIG[activeTab].zoom}
          />

          {KUTCH_LOCATIONS
            .filter((loc) => loc.type === activeTab)
            .map((loc) => (
              <Marker key={loc.id} position={loc.coords} icon={diamondIcon}>
                <Tooltip 
                  direction="top" 
                  offset={[0, -10]} 
                  opacity={1} 
                  permanent={false}
                >
                  <span className="map-tooltip-text">{loc.name}</span>
                </Tooltip>
              </Marker>
            ))}
        </MapContainer>
      </motion.div>

    </div>
  );
};

export default KutchMap;